import { getAuth, Auth } from 'firebase/auth';

import { getFirebaseApp } from './firebaseApp';

let auth: Auth | undefined;

export function getFirebaseAuth(): Auth {
  if (!auth) {
    auth = getAuth(getFirebaseApp());
  }
  return auth;
}
